import footer from '../_assests/_img/footer.svg';;
function Footer() {
  return (

    <footer className="main" role="contentinfo">
      <section className="footerGlobal">
        <div className="container-fluid">
          <div className="row">
						<nav>
							<ul>
								<li><a href="/accessibility-statement">Accessibility</a></li>
								<li><a href="https://www.leeds.gov.uk/Pages/Privacy-and-Data.aspx">Privacy Notice</a></li>
								<li><a href="https://www.leeds.gov.uk/Pages/TermsAndConditions.aspx">Terms and Conditions</a></li>
							</ul>
						</nav>
          </div>
          <div className="row">
            <div className="logo-footer">
              <img src={footer} alt="Leeds City Council logo" />
              <p>Copyright © Leeds City Council 2022. Release</p>
              <p>Official local authority website for Leeds providing information on local services.</p>
            </div>
          </div>
        </div>
      </section>
    </footer>

  );
}

export default Footer;
